import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 25"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.5 11.396v5.579c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436H9.9c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216v-5.95c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.856-.436 1.976-.436 4.216-.436h1.636m-3.75 4.167h6.428m-6.428 4.166h4.285m-4.285 4.167h2.143"
    />
    <path
      fill="currentColor"
      d="M20.796 1.282a.13.13 0 0 0-.258 0c-.035.305-.126.514-.268.655-.141.142-.35.233-.655.268a.13.13 0 0 0 0 .257c.3.034.514.125.659.268.145.142.237.35.264.652a.13.13 0 0 0 .258 0c.026-.297.118-.51.263-.656.146-.145.36-.238.656-.263a.13.13 0 0 0 0-.258c-.302-.027-.51-.12-.652-.264-.143-.146-.234-.36-.267-.659ZM18.498 2.13a.333.333 0 0 0-.663-.001c-.09.783-.323 1.321-.687 1.686-.365.364-.902.597-1.686.688a.333.333 0 0 0 0 .662c.77.087 1.32.32 1.695.687.372.365.609.902.678 1.678a.333.333 0 0 0 .664 0c.066-.764.303-1.313.677-1.687.374-.374.923-.611 1.686-.677a.333.333 0 0 0 0-.664c-.775-.07-1.312-.306-1.677-.678-.367-.374-.6-.924-.687-1.695Z"
    />
  </svg>
)
export default SvgComponent
